import { supabase } from './supabase';

export interface CustomerSegment {
  id?: string;
  name: string;
  description?: string;
  criteria: any;
  created_at?: string;
  updated_at?: string;
}

export async function getActiveNurtureSequences() {
  const { data, error } = await supabase
    .from('nurture_sequences')
    .select('*')
    .eq('is_active', true);

  if (error) {
    console.error('Error fetching nurture sequences:', error);
    return [];
  }

  return data;
}

export async function createCustomerSegment(segment: CustomerSegment) {
  const { data, error } = await supabase
    .from('customer_segments')
    .insert(segment)
    .select()
    .single();

  if (error) {
    console.error('Error creating customer segment:', error);
    throw error;
  }

  return data;
}

export async function enrollSegmentInNurtureSequence(segmentId: string, sequenceId: string) {
  const { data, error } = await supabase
    .from('segment_nurture_enrollments')
    .insert({
      segment_id: segmentId,
      sequence_id: sequenceId,
      enrolled_at: new Date().toISOString()
    })
    .select()
    .single();

  if (error) {
    console.error('Error enrolling segment in nurture sequence:', error);
    throw error;
  }

  return data;
}
